import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import DashboardWeb from './web';
import DashboardMobile from './mobile';
import DashboardDistribuidor from '../NewDashboard/DashboardDistribuidor';
import DashboardRevenda from '../NewDashboard/DashboardRevenda';
import { Content, ContentMobile } from './styles';


function Dashboard() {
	const [dashWeb, setDashWeb] = useState(window.innerWidth > 768);
	const { user } = useSelector((state) => state.auth);

	useEffect(() => {
		const handleResize = () => {
			setDashWeb(window.innerWidth > 768);
		};

		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	function loadDashboard() {
		if(user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' && user.dados.cargo.toLowerCase() !== 'distribuidor - filial' && user.dados.permissoes.view_pgm){
			return <DashboardDistribuidor />
		}

		if(user.dados.cargo.toLowerCase() !== 'industria' && user.dados.permissoes.view_pgm){
			return <DashboardRevenda />
		}

		if(user.dados.cargo.toLowerCase() === 'industria' && user.dados.permissoes.view_pgm){
			return <DashboardDistribuidor />
		}

		if(dashWeb){
			return <DashboardWeb />
		}

		return <DashboardMobile />
	}

	return (
		<>
			{dashWeb ? (
				<Content>
					{user.dados.permissoes.view_dashboard &&
						loadDashboard()
					}
				</Content>
			) : (
				<ContentMobile>
					{user.dados.permissoes.view_dashboard &&
						loadDashboard()
					}
				</ContentMobile>
			)}
		</>
	);
}

export default Dashboard;
